import {DefaultRootState} from 'react-redux';
import {ControlModel, GlassControlParameters} from '../types/control';
import {useSetSelector} from './set-selector';
import {useMemo} from 'react';
import {useMapSelector} from './map-selector';

export type CONTROL_WRAPPER = {
    id: string;
    isVirtual: boolean;
    bridgeDeviceId: string;
    glassControlParameters: Omit<GlassControlParameters, 'output_number'>;
    control: ControlModel;
};

export function useControlSelector<TState = DefaultRootState>() {

    const controlSet = useSetSelector(state => state.control.controlList);

    const controlList: CONTROL_WRAPPER[] = useMapSelector(
        state => state.control.controlList,
        control => ({
            id: control.id,
            bridgeDeviceId: control.bridge_device_id,
            isVirtual: false,
            glassControlParameters: (control.parameters as GlassControlParameters),
            control,
        }),
    );

    const virtualControlList: CONTROL_WRAPPER[] = useMapSelector(
        state => state.control.virtualControlList,
        virtualControl => ({
            id: virtualControl.id,
            bridgeDeviceId: virtualControl.bridge_device_id,
            isVirtual: true,
            glassControlParameters: virtualControl.parameters,
            control: controlSet[virtualControl.control_id],
        }),
        [controlSet],
    );

    return useMemo(() => [...controlList, ...virtualControlList], [controlList, virtualControlList]);
}
